import { render, staticRenderFns } from "./feedBait_page.vue?vue&type=template&id=d0c63886&scoped=true"
import script from "./feedBait_page.vue?vue&type=script&lang=js"
export * from "./feedBait_page.vue?vue&type=script&lang=js"
import style0 from "./feedBait_page.vue?vue&type=style&index=0&id=d0c63886&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c63886",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0c63886')) {
      api.createRecord('d0c63886', component.options)
    } else {
      api.reload('d0c63886', component.options)
    }
    module.hot.accept("./feedBait_page.vue?vue&type=template&id=d0c63886&scoped=true", function () {
      api.rerender('d0c63886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/feeder/feedBait_page.vue"
export default component.exports